<template>
  <div class="contain">
    <div class="team-msg">
      <div class="team-name">{{ teamName }}</div>
      <div class="server-center-name">{{ servicePointName }}</div>
    </div>
    <div class="bonusBanner">
      <div class="icon"  @click="handleBonus()"> <span>?</span> <span>如何获得</span> </div>
      <div :class="[totalBonus.toString().length  < 8 ? 'totalBonusNum': 'totalLongBonusNum']">{{ totalBonus.toLocaleString()}}</div>
      <img src="../../../src/assets/images/winterGame/rule/bonusBg.png">
    </div>
    <div class="listContain">
      <div class="getTitle">
        获取明细
      </div>
      <div class="getContent" v-for="(item,index) in getList" :key="index">
        <div class="bonusContent">
          <div class="bonusTitle">{{ item.title }}</div>
          <div class="bonusDate">{{ item.bonus_date }}</div>
        </div>
        <div class="bonusNum">+{{ item.bonus_amount }}</div>
      </div>
    </div> 
  </div>
</template>

<script>
import { agentBonus } from "../../api/winterGame";

export default {
  computed: {},
  components: {
   
  },
  data() {
    return {
      currentCampusId:'',
      totalBonus: 211,
      getList:[],
      pageSize:10,
      pageNum:1,
      loading: false,
      finished: false,
      isLoadingData: false,
      teamName:'',
      servicePointName:'',
      agentBonusData:'',
      campusId:''
    };
  },
  created() {
    document.title = this.$route.meta.title || "通知中心";
  },
  mounted() {
    this.teamName = this.$route.query.teamName || "";
    this.servicePointName = this.$route.query.servicePointName || "";
    this.campusId = this.$route.query.campusId;
    this.queryAgentBonus();
  },
  methods: {
    handleBonus() {
      this.$router.push("/winterGame/bonusRules");
    },
    async queryAgentBonus() {
      let params = {
        param: this.campusId,
      };
      let res = await agentBonus(params);
      if (res.code == 0) {
        if (res.data) {
          this.totalBonus = res.data.bonus_total_amount;
          this.getList = res.data.list;
        }
      } else {
        Toast(res.message);
      }
    },
  },
};
</script>


<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .contain {
    height: 100vh;
    overflow: auto;
    padding: 0 48px 48px;
    .team-msg {
      margin: 32px 0 20px;
      text-align: center;
      div {
        font-size: 28px;
        color: #68707d;
        line-height: 40px;
      }
      .team-name {
        font-size: 40px;
        font-weight: 600;
        color: #323232;
        line-height: 56px;
        margin-bottom: 8px;
      }
    }
    .bonusBanner {
      text-align: center;
      position: relative;
      .icon { 
        position: absolute;
        right: 32px;
        top: 54px;
        display: flex;
        align-items: center;
        color: #830C0D;
        span:nth-child(1) {
          display: inline-block;
          width: 22px;
          height: 22px;
          border: 2px solid #830C0D;
          border-radius: 50%;
          font-size: 20px;
          line-height: 20px;
        }
        span:nth-child(2) {
          font-size: 24px;
          margin-left: 8px;
        }
      }
      .totalBonusNum{
        position: absolute;
        width: 384px;
        height: 120px;
        text-align: center;
        line-height: 110px;
        right: 20px;
        top: 96px;
        font-size: 64px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #C32200;
      }
      .totalLongBonusNum{
        position: absolute;
        width: 384px;
        height: 120px;
        text-align: center;
        line-height: 110px;
        right: 20px;
        top: 96px;
        font-size: 46px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #C32200;
      }
      img {
        width: 100%;
      }
    }
    .listContain {
      .getTitle {
        font-size: 34px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #323232;
        padding: 36px 0 30px;
        border-bottom: 2px solid #DEE5F0;
      }
      .getContent {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 46px;
        .bonusTitle {
          font-size: 32px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #323232;
        }
        .bonusDate {
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #68707D;
        }
      }
      .bonusNum {
        font-size: 48px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #EE4B4E;
      }
    }
  }
</style>
